<script>
  import {getContext, onMount} from 'svelte';
  import {Button} from '@px/button';
  import {PATHS} from '@/const/paths';
  import {fixLink$} from '@/store/lang';
  import {isLogin$} from '@/store/user';
  import {fiatABTest$} from '@/modules/fiat/streams';
  import {contractMarkets$} from '@/modules/markets/streams';
  import {IMAGES} from '../images';
  import {loadTasksList, tasks$} from '../streams';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  let steps = [];

  $: primaryBtn = !$isLogin$ ? 'step1' : !checkDepositTask($tasks$) ? 'step2' : 'step3';
  $: steps = getSteps($fiatABTest$, $contractMarkets$);

  onMount(() => $isLogin$ && loadTasksList());

  function getSteps(fiatABTest, contractMarkets) {
    return [
      {
        icon: 'STEP1',
        title: LG(lang.Step1),
        desc: LG(lang.Step1Desc),
        btnType: 'step1',
        btnText: LG(lang.SignUp),
        alt: 'fund your account',
        href: $fixLink$(PATHS.REGISTER.pathname),
      },
      {
        icon: 'STEP2',
        title: LG(lang.Step2),
        desc: LG(lang.Step2Desc),
        btnType: 'step2',
        btnText: LG(lang.BuyNow),
        alt: 'deposit crypto',
        href: $fixLink$(fiatABTest ? PATHS.FIAT_BUY_CRYPTO_PLACE_ORDER.pathname : PATHS.OTC_LEGEND_TRADING.pathname),
      },
      {
        icon: 'STEP3',
        title: LG(lang.Step3),
        desc: LG(lang.Step3Desc, {Number: contractMarkets?.length}),
        btnType: 'step3',
        btnText: LG(lang.TradingNow),
        alt: 'trade crypto',
        href: '/trade/BTCUSD',
      },
    ];
  }

  function checkDepositTask(tasks) {
    return tasks.some((o) => o.taskId === 10 && o.status === 200);
  }

  function buttonClickHandler(step) {
    return function () {
      location.href = step.href;
    };
  }
</script>

<style>
  .wrap {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 80px 0;
    width: 1200px;
  }
  .caption {
    margin-top: 0;
    margin-bottom: 24px;
    font-size: 48px;
  }
  .title {
    margin-top: 0;
  }
  .desc {
    line-height: 22px;
  }
  .sub-title {
    margin-bottom: 48px;
    font-size: 18px;
  }
  .card {
    box-sizing: border-box;
    border-radius: 20px;
    padding: 36px 24px;
    width: 384px;
    background: #fff;
  }
  .card + :global(.card) {
    margin-left: 24px;
  }
  .desc {
    color: #777b83;
  }
  .card-wrap :global(.medium.text:hover:before) {
    background: transparent;
  }
  @media screen and (max-width: 640px) {
    .wrap {
      padding: 24px 16px 40px 16px;
      width: 100%;
      text-align: left;
    }
    .caption {
      margin-bottom: 12px;
      font-size: 18px;
    }
    .sub-title {
      margin-bottom: 24px;
      font-size: 14px;
    }
    .card-wrap {
      flex-direction: column;
    }
    .card {
      padding: 24px 16px;
      width: 100%;
    }
    .card + :global(.card) {
      margin: 20px 0 0 0;
    }
    .title {
      margin-bottom: 12px;
    }
    .desc {
      margin-bottom: 28px;
    }
  }
</style>

<section class="wrap tc">
  <h2 class="caption">{LG(lang.WeMakeCryptoEasy)}</h2>
  <div class="sub-title fw2">{LG(lang.StepsTitle)}</div>
  <div class="card-wrap df">
    {#each steps as step, i}
      <div class="card df fdc aifs jcsb tl">
        <div>
          <img class="mb24" width="60" height="60" src={IMAGES[step.icon]} alt={step.alt} />
          <h3 class="title mb20 f24 T1">{step.title}</h3>
          <div class="desc mb24 T3">{@html step.desc}</div>
        </div>
        {#if (i === 0 && !$isLogin$) || i !== 0}
          <Button on:click={buttonClickHandler(step)} class={primaryBtn !== step.btnType ? 'p0' : ''} type={primaryBtn === step.btnType ? 'primary' : 'text'}>
            <div class="df aic fw3">
              {step.btnText}
              {#if primaryBtn !== step.btnType}
                <i class="iconfont db ml8 f14 BLUE cp b">&#xe60b;</i>
              {/if}
            </div>
          </Button>
        {/if}
      </div>
    {/each}
  </div>
</section>
